import React from 'react';
import PropTypes from 'prop-types';

export default function SeoText (props) {
  return props.text
      ? (<div className='page-seo-text no-print' dangerouslySetInnerHTML={{__html: props.text}} />)
      : null;
}

SeoText.propTypes = {
  text: PropTypes.string
};

SeoText.defaultProps = {
  text: null
};



// WEBPACK FOOTER //
// ./src/ui/Widgets/SeoText.jsx